import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  BoostersContainer,
  MyBoosterHeader,
  MyBoosterHeaderSubtitle,
  MyBoosterContent,
  CardContent,
  CardTitle,
  MyBoosterHeaderContent,
  IconWrapper,
  SkeletonCardWrapper,
} from '../Boosters.styled';
import { Card } from '../../../common/sharedComponents/Card';

export function MyBoostersSkeleton () {
  const skeletonCount = 5;

  return (
    <BoostersContainer>
      <MyBoosterHeader>
        <MyBoosterHeaderContent>
          <Skeleton width={200} height={32} />
          <MyBoosterHeaderSubtitle>
            <Skeleton width={150} height={24} />
            <Skeleton width={200} height={24} />
          </MyBoosterHeaderSubtitle>
        </MyBoosterHeaderContent>
        <IconWrapper>
          <Skeleton width={60} height={60} circle={true} />
        </IconWrapper>
      </MyBoosterHeader>
      <MyBoosterContent>
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <SkeletonCardWrapper key={index}>
            <Card>
              <CardContent>
                <CardTitle>
                  <Skeleton width={24} height={24} circle={true} />
                  <Skeleton width={250} height={24} />
                </CardTitle>
                <IconWrapper>
                  <Skeleton width={24} height={24} />
                </IconWrapper>
              </CardContent>
            </Card>
          </SkeletonCardWrapper>
        ))}
      </MyBoosterContent>
    </BoostersContainer>
  );
}
